import React, { useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../components/tables/ReportsTable';

const serviceTypes = [
  'Recharge',
  'Bill Payment',
  'UPI',
  'AEPS',
  'DMT',
  'BBPS',
  'FASTag'
];

const txnStatuses = ['Successful', 'Pending', 'Failed', 'Refund Initiated'];

const generateRetailerTxnData = (count = 160) => {
  return Array.from({ length: count }, (_, index) => {
    const txnDate = new Date(
      2025,
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1,
      Math.floor(Math.random() * 24),
      Math.floor(Math.random() * 60)
    );

    const amount = parseFloat((Math.random() * 12500 + 200).toFixed(2));
    const charge = parseFloat((amount * 0.007).toFixed(2));
    const commission = parseFloat((amount * 0.0055).toFixed(2));

    return {
      txnId: `RDTXN${String(index + 1).padStart(6, '0')}`,
      date: txnDate.toISOString().split('T')[0],
      time: txnDate.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }),
      retailerCode: `RET${String(Math.floor(Math.random() * 90000) + 10000)}`,
      retailerName: `Retailer ${Math.floor(Math.random() * 320) + 1}`,
      service: serviceTypes[Math.floor(Math.random() * serviceTypes.length)],
      amount,
      charge,
      commission,
      status: txnStatuses[Math.floor(Math.random() * txnStatuses.length)],
      rrn: Math.random().toString(36).substring(2, 10).toUpperCase(),
      referenceId: `RR${Math.random().toString(36).substring(2, 9).toUpperCase()}`,
      location: ['Pune', 'Nagpur', 'Nashik', 'Aurangabad', 'Kolhapur'][Math.floor(Math.random() * 5)],
    };
  });
};

const formatCurrency = (value) =>
  `₹${Number(value || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

const ReportsRetailerTransactions = () => {
  const [transactions] = useState(() => generateRetailerTxnData(200));

  const columns = useMemo(
    () => [
      { key: 'txnId', label: 'Txn ID' },
      { key: 'date', label: 'Date' },
      { key: 'time', label: 'Time' },
      { key: 'retailerCode', label: 'Retailer Code' },
      { key: 'retailerName', label: 'Retailer Name' },
      { key: 'location', label: 'Location' },
      { key: 'service', label: 'Service' },
      {
        key: 'amount',
        label: 'Amount (₹)',
        render: (_, value) => formatCurrency(value)
      },
      {
        key: 'charge',
        label: 'Charge (₹)',
        render: (_, value) => formatCurrency(value)
      },
      {
        key: 'commission',
        label: 'Commission (₹)',
        render: (_, value) => formatCurrency(value)
      },
      {
        key: 'status',
        label: 'Status',
        render: (row) => {
          const variant =
            row.status === 'Successful'
              ? 'success'
              : row.status === 'Pending'
              ? 'warning'
              : row.status === 'Failed'
              ? 'danger'
              : 'info';

          return <span className={`badge bg-${variant}`}>{row.status}</span>;
        }
      },
      { key: 'rrn', label: 'RRN' },
      { key: 'referenceId', label: 'Reference ID' }
    ],
    []
  );

  return (
    <Container fluid>
      <ReportsTable
        data={transactions}
        reportType="Distributor_RetailerTransactions"
        columns={columns}
        title="Retailer Transaction Report"
        cellPaddingY={8}
      />
    </Container>
  );
};

export default ReportsRetailerTransactions;

